import CloneManaSource from "../../mana/nodes/action/unique/CloneManaSource"
import CastingEntity, { CastingEntityOptions } from "../CastingEntity"
import DamageParticleEffect from "../particle-effects/DamageParticleEffect"
import ParticleEffectEntity from "../particle-effects/ParticleEffectEntity"

export type MagicCloneOptions = {} & CastingEntityOptions

export default class MagicClone extends CastingEntity {

	manaSource = undefined as (undefined | CloneManaSource)

	constructor(options: MagicCloneOptions) {
		super({
			...options,

			symbol: '🐱‍👤',
		})
	}

	getDeathParticle(): ParticleEffectEntity {
		return new DamageParticleEffect({
			world: this.world,

			x: this.position.x,
			y: this.position.y,

			symbol: "☁",
		})
	}

	tick(delta: number) {
		super.tick(delta)

		if (this.manaSource) {
			this.manaSource.tick(delta)
		}
	}

}